import { GenericButton } from "../../../components/UI-KIT/GenereicButton";
import { T } from "../../../styles/Theme";
import { CardContent, CardStyled, FooterContainer, MultilineText, PrimaryCard, SecondaryCard } from "../../../styles/Screens/Recommendations";
import TextValues from "../../../TextValues/index.json";
import styled from "styled-components";
import { CheckIconSmall } from "../../../assets/Icons/CheckIconSmall";
import { useContext, useEffect, useState } from "react";
import { ChatIcon } from "../../../assets/Icons/ChatIcon";
import TypingEffect from "../../../components/TypingEffect";
import ThreeDots from "../../../components/ThreeDots";
import { parseQuestionsAndAnswers } from "../../../utils/openai";
import axios from "axios";

import { CHAT_BETA_URL, ECOMMERCE_URL } from "../../../env";
import ShoppingCartIcon from "../../../assets/Icons/ShoppingCartIcon";
import { EssentialsDataContext } from "../../../contexts/EssentialsDataContext";
import { AddToCart } from "../../../utils/ShoppingCart";

interface ICardSlider {
  data: any;
  onSelectService: any;
}

export const CardSlider = ({ data, onSelectService }: ICardSlider) => {
  let description = data.description ? data.description.split("--") : [];
  description = description.filter((el: any) => el !== "");

  let actionData: any = {
    action_type_id: 1,
    data: {
      name: data.name,
      price: data.price,
      currency: "S/",
      quantity: 1
    }
  }

  const [chat, setChat] = useState("");
  const [finalForm] = useContext(EssentialsDataContext);

  useEffect(() => {
    const config = {
      headers: {"Content-Type": "application/json",}
    };
    const bodyTest = JSON.stringify({
      data: parseQuestionsAndAnswers(finalForm),
      product: data.name,
      type: 3,
      number_of_characters: 250,
      emoji: true,
      proposal_type: 3
    })
    axios.post(`${CHAT_BETA_URL}/predict/`, bodyTest, config)
      .then(response => {
        setChat(response.data.result);
      });
  }, []);

  if (data?.type?.name !== "service") {
    return (
      <CardStyled>
      <FooterContainer>
        <MultilineText>
          {data?.name}
        </MultilineText>
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <div>
        {(data?.links[0]?.link) && (
        <ButtonStandard
              onClick={() => {
                window.open(data?.links[0].link);
                onSelectService();
              }}
            >
              <span style={{'fontSize': '16px'}}>
                Ver distribuidores
              </span>
            </ButtonStandard>)
            }
            </div>
          </div>
      </FooterContainer>
    </CardStyled>
    )
  }

  return (
    <CardStyled>
      <PrimaryCard>
        <p style={{'fontSize': `${T.fontSizes.small}`, 'paddingBottom': '10px'}}>{TextValues.adviserTitle}</p>
        <p className="titleService">{data.name}</p>
        <ImageContainer>
          <img src={data?.images[0].image_url} alt="imagen" />
        </ImageContainer>
      </PrimaryCard>
      <CardContent>

        <SecondaryCard>
        <div className="match">Match: 100%</div>
        <ul>
          {description.map((value: any, i: number) => (
              <li className="down_arrow" key={i}>
                <span className="icon">
                  <CheckIconSmall />
                </span>
                <p>{value}</p>
              </li>
            )
          )}
        </ul>
        <div className="buttonContainer">
          <GenericButton
            bg={T.secondary}
            c="white"
            onClick={() => {
              window.open(data?.links[0].link);
              onSelectService();
            }}
          >
            <span style={{'fontSize': '16px'}}>
              {(data?.id === 2131) ? "Agendar demo" : TextValues.buttons.goToService}
            </span>
          </GenericButton>
        </div>
        {/* <div className="buttonContainer">
          <ButtonStandard
            onClick={() => AddToCart(ECOMMERCE_URL, data?.properties[0]?.shopifyId)}
          >
            <ShoppingCartIcon className="shoppingCartIcon"/>
              <span style={{'fontSize': '16px'}}>
                Agregar al carro
              </span>
          </ButtonStandard>
        </div> */}
      </SecondaryCard>
      </CardContent>
      <FooterContainer>
        {(chat !== "") ? (
          <div className="footerContent">
            <ChatIcon/><TypingEffect text={chat} />
          </div>)
          : (
            <>
              <div className="footerContent"><ChatIcon/><ThreeDots /></div>
            </>
          )}
      </FooterContainer>
    </CardStyled>
  );
};

const ImageContainer = styled.div`
  width: 100%%;
  height: 100%%;
  display: flex;
  justify-content: center;
  align-items: left;
  // pagdding with good space
  padding: 20px 10px 20px 0;
  
  img {
    width: 200px;
    height: 200px;
  }
`;

export const ButtonStandard = styled.button`
  background-color: ${T.secondary};
  border: 2px solid #FFFFFF;
  border-radius: ${T.borderRadius.button};
  color: white;
  font-size: ${T.fontSizes.medium};
  font-weight: ${T.fontWeights.bold};
  width: 180px;
  height: 46px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #FFFFFF;
    color: ${T.secondary};
    border: 2px solid ${T.secondary};

    .shoppingCartIcon {
      fill: ${T.secondary};
    }
  }

  &:active {
    color: white;
    transform: scale(0.95);
  }

  &:disabled {
    background-color: ${T.gray};
    border: 1px solid ${T.gray};
    pointer-events: none;
    color: white;
  }

  .shoppingCartIcon {
    margin-right: 10px;
    width: 16px;
    height: 16px;
    fill: #FFFFFF;
    margin: 0 8px -2px 0;
  }
`;